export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login'),
  },
  {
    path: '/two-factor',
    name: 'two-factor',
    component: () => import('@/pages/TwoFactor'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/pages/Logout'),
  },
  {
    path: '/federated-login',
    name: 'federated-login',
    component: () => import('@/pages/FederatedLogin'),
  },
]
